export default "__VITE_PUBLIC_ASSET__70563d52__"